import API_PATH from '@/constants/apiPath'
import Toastr from 'toastr'

const state = {}

const mutations = {}
const actions = {
    async logout ({ commit }) {
        try {
            const resp = await this.$axios.post(API_PATH.logout)
            delete localStorage.token
            if (resp && resp.data && resp.data.displayMsg && resp.data.displayMsg.s) {
                Toastr.success(resp.data.displayMsg.s.head, resp.data.displayMsg.s.msg)
                return true
            } else {
                return false
            }
        } catch (err) {
            console.log(err)
            delete localStorage.token
            return false
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
